import { ReactComponent as TriangleAlert } from "assets/images/iconsV2/triangle-alert.svg";
import Badge from "components/v2/Badge/Badge";

import "./ScheduleFieldErrorBadge.scss";

interface ScheduleFieldErrorBadgeProps {
  message: string;
}

export default function ScheduleFieldErrorBadge({ message }: ScheduleFieldErrorBadgeProps) {
  return (
    <div>
      <Badge
        type="category-badge"
        size="sm"
        color="error"
        variant="icon-leading"
        icon={<TriangleAlert className="rfv2-schedule-field-error-badge__icon" />}
        label={message}
      />
    </div>
  );
}
